import { currencyFormat } from 'common/formats/formats';
import { ComparisonCompany } from 'dashboard409a/services/types';
import { RowConfigProps } from '../types';

// Titles
export const TABLE_TITLE = 'Performance Metrics';
export const TABLE_SECOND_TITLE = 'Ticker Symbol';
export const TABLE_THIRD_TITLE = 'LTM Revenue';
export const TABLE_FOURTH_TITLE = 'LTM Revenue Growth';
export const TABLE_FIFTH_TITLE = 'NTM Revenue';
export const TABLE_SIXTH_TITLE = 'NTM Revenue Growth';
export const TABLE_SEVENTH_TITLE = 'LTM EBITDA';
export const TABLE_EIGHTH_TITLE = 'NTM EBITDA';
export const TABLE_NINTH_TITLE = 'Gross Margin';
export const TABLE_TENTH_TITLE = 'EBITDA Margin';
export const TABLE_ELEVENTH_TITLE = 'Tangible Book Value';
export const TABLE_TWELFTH_TITLE = 'Net Income';

const baseCurrencyFormat = currencyFormat({ fractionDigits: 1 });

const getCompanyRows = (companies: ComparisonCompany[] | undefined) =>
  companies && companies.length > 0
    ? companies.map((company: ComparisonCompany) => ({
      value: company.name,
      alias: `company-${company.name}`,
      readOnly: true,
      gridType: 'number',
      format: baseCurrencyFormat,
      allowNegativeValue: true,
    }))
    : [];

const rowConfig = ({ companies }: RowConfigProps) => [
  {
    className: 'table-header comparison-companies-table-header division-bottom-only',
    value: TABLE_TITLE,
    alias: 'title',
    readOnly: true,
    gridType: 'string',
  },
  ...getCompanyRows(companies),
];

export default rowConfig;
